import { tryLoadDependencies, tryLoadLightDOMStyles, WebAwesomeComponent } from '../../Global/loadDependency'
import { getNavEnterpriseMenuStyles } from './NavEnterpriseMenu.styles'
import type { } from './types/NavEnterpriseMenu.type'

const t = document.createElement('template')
t.innerHTML = `
  <nav class="nav-enterprise-menu" role="navigation" aria-label="Enterprise Navigation">
    <slot></slot>
  </nav>
`
const TemplateNavEnterpriseMenu = t

class NavEnterpriseMenu extends HTMLElement {
    private collapseHandler: ((e: Event) => void) | null = null
    private parentNavEnterprise: HTMLElement | null = null

    constructor() {
        super()

        tryLoadDependencies(document, [WebAwesomeComponent.Details])
        tryLoadLightDOMStyles('NavEnterpriseMenu.css')

        const shadow = this.attachShadow({ mode: 'open' })
        shadow.appendChild(getNavEnterpriseMenuStyles().content.cloneNode(true))
        shadow.appendChild(TemplateNavEnterpriseMenu.content.cloneNode(true))
    }

    connectedCallback() {
        document.AscendAwesome?.LogManager?.logDebug('NavEnterpriseMenu connectedCallback')

        // Listen for collapse events from parent NavEnterprise
        this.collapseHandler = (e: Event) => this.onParentCollapse(e)
        this.parentNavEnterprise = this.closest('ts-nav-enterprise') as HTMLElement | null
        this.parentNavEnterprise?.addEventListener('nav-collapse-change', this.collapseHandler)

        // Check if parent is already collapsed
        if (this.parentNavEnterprise?.classList.contains('collapsed')) {
            this.setMenuCollapsed(true)
        } else {
            this.setMenuCollapsed(false)
        }
    }

    disconnectedCallback() {
        if (this.collapseHandler) {
            this.parentNavEnterprise?.removeEventListener('nav-collapse-change', this.collapseHandler)
            this.collapseHandler = null
        }
        this.parentNavEnterprise = null
    }

    private onParentCollapse(e: Event) {
        if (e instanceof CustomEvent) {
            const { collapsed } = e.detail
            this.setMenuCollapsed(collapsed)
        }
    }

    private setMenuCollapsed(collapsed: boolean) {
        const nav = this.shadowRoot?.querySelector('.nav-enterprise-menu')
        if (nav) {
            nav.classList.toggle('collapsed', collapsed)
        }
    }
}

if (!customElements.get('ts-nav-enterprise-menu')) {
    customElements.define('ts-nav-enterprise-menu', NavEnterpriseMenu)
}
export { NavEnterpriseMenu }
